import BaseHeadline from "../../../components/general/BaseHeadline"
import { motion } from "framer-motion"
import BasePrimaryButton from "../../../components/general/BasePrimaryButton"
import { HeroType } from "../../../types/index"



export default function Hero(props: HeroType) {

    return (
        <section className="w-full h-screen flex flex-col justify-center items-center relative px-4">
            <div className="flex flex-col items-center justify-center z-30">

                <BaseHeadline
                    label={props.data?.label}
                    tag="h1"
                    headline={props.data?.headline}
                    text={props.data?.text}
                    width="w-fit"
                    headlineClassProps="text-center max-w-4xl"
                    center
                />
               
                <BasePrimaryButton text={"Kontaktieren Sie Uns!"} url={"/contact#_"} classProps="mt-6" />
            </div>
            <div className="absolute top-0 left-0 w-full h-screen flex flex-col justify-center items-center z-0 ">
                <motion.span
                    animate={{ opacity: [0.15, 0.5, 0.15] }}
                    transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                    className="text-[60rem] font-bold text-center pt-32 font-wicode text-outline-xthick">
                    W
                </motion.span>

            </div>
            <div className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-full max-w-6xl h-screen flex flex-col justify-center items-center z-10 bg-gradient-to-r from-base-100 via-transparent to-base-100" />
        </section>
    )
}
